import { features } from "@/mocks/siteContent";

const tones = [
  { bubble: "bg-primary-500", soft: "bg-primary-100", text: "text-primary-700", chip: "bg-primary-50 border-primary-200" },
  { bubble: "bg-accent-500", soft: "bg-accent-100", text: "text-accent-700", chip: "bg-accent-50 border-accent-200" },
  { bubble: "bg-secondary-500", soft: "bg-secondary-100", text: "text-secondary-800", chip: "bg-secondary-50 border-secondary-200" },
];

export default function Features() {
  return (
    <section id="features" className="section-pad scroll-mt-20 bg-background-50">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium tracking-wide text-primary-600">核心能力</p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">六大提取能力，一处搞定</h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            无论要留档吃瓜、收集素材还是分析内容，都能按需抽取，把网页变成可随时调用的资源。
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {features.map((f, i) => {
            const t = tones[i % tones.length];
            return (
              <article
                key={f.title}
                className="group flex flex-col rounded-2xl border border-background-200/80 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-background-300"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-xl text-background-50 ${t.bubble}`}
                  >
                    <i className={`${f.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <span className={`rounded-full border px-2.5 py-1 text-[11px] font-medium ${t.chip}`}>
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-bold text-foreground-900">{f.title}</h3>
                <p className="mt-2 text-sm text-foreground-600">{f.intro}</p>
                <ul className="mt-4 space-y-2 border-t border-dashed border-background-200 pt-4">
                  {f.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-xs text-foreground-700">
                      <i className={`ri-check-line mt-0.5 text-sm font-bold ${t.text}`} aria-hidden="true" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}